<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: [
          {
            type: "sunburst",
            data: [
              {
                name: "Parent 1",
                children: [
                  { name: "Child 1", value: 10 },
                  { name: "Child 2", value: 20 }
                ]
              },
              {
                name: "Parent 2",
                children: [
                  { name: "Child 3", value: 15 },
                  { name: "Child 4", value: 25 }
                ]
              }
            ],
            radius: [0, "80%"]
          }
        ]
      }
    };
  }
};
</script>
